import * as React from 'react';
import * as Modal from 'react-modal';

import {Button} from '../util';

interface ConfirmModalProps {
	isOpen: boolean;
	confirmText: string;
	disabled?: boolean;
	onConfirm(): void;
	onCancel?(): void;
}

export default class ConfirmModal extends React.Component<ConfirmModalProps, {}> {

	public render() {
		return <Modal
			contentLabel='confirm'
			isOpen={this.props.isOpen}
			onRequestClose={this.props.onCancel}
		>
			{this.props.children}
			<p className='center'>
				{this.props.onCancel && <Button color='link' onClick={this.props.onCancel}>Cancel</Button>}
				<Button
					onClick={this.props.onConfirm}
					disabled={this.props.disabled}
				>
					{this.props.confirmText}
				</Button>
			</p>
		</Modal>;
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/config-editor/ConfirmModal.tsx